<template>
  <div id="app" :class="{ 'debug-screens': devMode }">
    <!-- <Header></Header> -->
    <div class="container mx-auto">
      <div class="px-4 xl:px-0 h-full pt-20">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
// import Header from "@/components/header";
export default {
  name: "App",
  components: {
    // Header
  },
  props: ["imageHeader"],
  mounted: function() {
    console.log(this.$route);
    console.log(process.env.NODE_ENV);
  },
  computed: {
    // a computed getter
    devMode: function() {
      // `this` points to the vm instance
      return process.env.NODE_ENV == "development";
    }
  }
};
</script>
